module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ff746430a87f7bc201d151b49ade12e6.png";